<script setup lang="ts">
import DataTable from '@/onenetwork/components/datatable/DataTable.vue'
import { computed, onMounted, ref, watch } from 'vue'
import CustomerCell from '@/modules/contract/components/parts/CustomerCell.vue'
import RealEstateCell from '@/modules/contract/components/parts/RealEstateCell.vue'
import BrokerAPI from '@/modules/broker/constants/broker.api.uri.const';
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant';

interface Props {
  account: object | null,
  currentTab?: string,
}

const props = defineProps<Props>()

const loading = ref<boolean>(false)
const pageSize = ref(10)
const page = ref(0)
const dataSource = ref({
  list: [],
  totalPage: 0,
  totalRecords: 0,
})

const handleChangePage = (page: number) => {
  if (page !== page.value) {
    page.value = page
    requestFetchData()
  }
}

const handleChangePageSize = (size: number) => {
  if (size !== pageSize.value) {
    pageSize.value = size
    page.value = 1 // Reset to first page when changing page size
    requestFetchData()
  }
}


const requestFetchData = async () => {
  try{
    const url = BrokerAPI.broker.customer_services.replace(':id', props.account?.id)
    const res = await APIClient.get(url, {
      params: {
        page: page.value,
        page_size: pageSize.value,
        type: 'under_care',
      }
    });

    const { data } = res.data;
    console.log(data, 'data');

    if (res.data.code === 200) {
      dataSource.value = {
        list: (data.data || []).map((item: any) => ({
          id: item.id,
          customer: {
            ...item.customer,
            profile_pic: item.customer.avatar?.url?.thumbnail || '',
            name: item.customer.name || item.customer.full_name,
          },
          listing: {
            thumb: item.listing.photos && item.listing.photos.length > 0 ? item.listing.photos[0]?.url.thumbnail : '',
            title: item.listing.title,
            region: item.listing.address,
          },
        })),
        totalPage: data.last_page,
        totalRecords: data.total,
      }
    }


  } catch (e) {

  }
}

watch(() => props.currentTab, (newTab) => {
  if (newTab === '4') {
    requestFetchData()
  }
})

onMounted(() => {
  requestFetchData()
})
</script>

<template>
  <data-table
    :loading="loading"
    :tableConfig="{
      canShowHide: false,
      columns: {
        // info: { label: 'Tình trạng', component: markRaw(ConsultantStateCell), visible: true, sort: false, config: {} },
        customer: { label: 'Khách hàng', component: CustomerCell, visible: true, class: '', sort: false, config: {} },
        listing: { label: 'Sản phẩm tư vấn', component: RealEstateCell, visible: true, sort: false, class: '', config: {} },
      }
    }"
    :page-size="pageSize"
    :page="page"
    :total-page="dataSource?.totalPage || 0"
    :total-records="dataSource?.totalRecords || 0"
    :data="dataSource?.list || []"
    @page-changed="handleChangePage"
    @pagesize-changed="handleChangePageSize"

  />
</template>

<style scoped>

</style>
